import { defineMessages } from 'react-intl'

export default defineMessages({
  createModalTitle: {
    id: 'CreateLegalEntityFormPresenter.createModalTitle',
    defaultMessage: 'Create new entity',
  },
  errorToastTitle: {
    id: 'CreateLegalEntityFormPresenter.errorToastTitle',
    defaultMessage: 'Could not create entity',
  },
})
